import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DarkThemeIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M18.9 11.7001V8.7001M18.9 8.7001V5.7001M18.9 8.7001L21.9 8.7001M18.9 8.7001H15.9M14.1 5.7001V3.9001M14.1 3.9001V2.1001M14.1 3.9001L15.9 3.9001M14.1 3.9001L12.3 3.9001M21.2999 14.9395C20.3976 15.2132 19.4403 15.3603 18.4487 15.3603C13.0307 15.3603 8.63851 10.9681 8.63851 5.55013C8.63851 4.55891 8.78552 3.60203 9.05892 2.7001C5.03148 3.92148 2.09998 7.66314 2.09998 12.0895C2.09998 17.5075 6.49213 21.8996 11.9101 21.8996C16.3369 21.8996 20.0789 18.9676 21.2999 14.9395Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

DarkThemeIcon.displayName = 'DarkThemeIcon';
